import { DisabledReason } from './disabled-reason';

export interface DisabledDetailsStateModel {
  deleteDate: Date | null;
  disabledDate: Date | null;
  reason: DisabledReason | null;
  upcomingPayment: boolean;
}

export interface SerializedDisabledDetails {
  deleteDate: string | null;
  disabledDate: string | null;
  reason: DisabledReason | null;
  upcomingPayment: boolean;
}
